import { ENV } from '../config/env';

export const API_BASE_URL = ENV.API_BASE_URL;

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'agent_auth_token',
  USER_DATA: 'agent_user_data',
} as const;

/** Dispatched on agent login / logout so listeners (e.g. in-app popup gate) can refetch */
export const AGENT_AUTH_TOKEN_CHANGED_EVENT = 'agent-auth-token-changed';
